<script>
  import { get } from 'svelte/store';
  import { onMount, onDestroy } from 'svelte';
  import { imageStore, editStore, sessionStore } from '../stores';
  import features from '../components/features.js';
  // 기존 유틸리티는 이제 하위 컴포넌트 안에서 사용한다.
  // 기존 유틸리티는 이제 하위 컴포넌트 안에서 사용한다.
  import FeatureListSection from '../EditorV2Pages/FeatureListSection.svelte';
  import OptionAreaSection from '../EditorV2Pages/OptionAreaSection.svelte';
  import HistoryAreaSection from '../EditorV2Pages/HistoryAreaSection.svelte';
  import ImageAreaSection from '../EditorV2Pages/ImageAreaSection.svelte';
  import { constructUrl } from '../utils/apiClient';

  // 모바일 유연성을 위해 상세 UI 로직을 별도 컴포넌트로 옮겼다.

  onMount(() => {
    window.scrollTo(0, 0); // 스크롤 위치를 맨 위로 이동해 헤더에 내용이 가려지지 않도록 함
    const updateOverflow = () => { document.body.style.overflow = window.innerWidth <= 800 ? '' : 'hidden'; };
    updateOverflow();
    window.addEventListener('resize', updateOverflow);

    // 호환성을 위해 탭 상태를 보장하고 기본으로 업로드 기능을 선택한다.
    const uploadFeature = features.find(f => f.id === 'upload_image');
    editStore.update(store => ({
      ...store,
      selectedTab: 'edit',
      selectedFeature: features.find(feature => feature.id === store.selectedFeature?.id && !feature.disabled) || uploadFeature
    }));

    // 대시보드를 열지 않아도 작업 완료 시 로딩 상태를 해제
    const taskCompletedHandler = (event) => {
      const { resultImage, id } = event.detail || {};
      if (id !== get(editStore).currentTaskId) return;
      if (resultImage) {
        imageStore.update(store => ({ ...store, resultImage }));
      }
      editStore.update(store => ({ ...store, isLoading: false }));
    };
    document.addEventListener('taskCompleted', taskCompletedHandler);

    // 새로고침 후 서버 URL만 남아 있는 경우 이미지를 불러와 미리보기 URL 생성
    if (!$imageStore.uploadedImageUrl && $imageStore.serverImageUrl) {
      fetch(constructUrl($imageStore.serverImageUrl))
        .then(res => res.blob())
        .then(blob => {
          const url = URL.createObjectURL(blob);
          const file = new File([blob], 'uploaded');
          const img = new Image();
          img.onload = () => {
            imageStore.update(store => ({
              ...store,
              uploadedImageUrl: url,
              uploadedImage: file,
              imageWidth: img.width,
              imageHeight: img.height
            }));
          };
          img.src = url;
        })
        .catch(e => console.error('서버 이미지 로드 오류:', e));
    }

    return () => {
      window.removeEventListener('resize', updateOverflow);
      document.removeEventListener('taskCompleted', taskCompletedHandler);
    };
  });

  // 결과 이미지 변화에 관계없이 taskCompleted 이벤트에서
  // 로딩 상태를 처리하므로 별도의 reactive 구문은 필요하지 않음

  onDestroy(() => {
    document.body.style.overflow = '';
  });
</script>

<div class="editorv2-container">
  <FeatureListSection />
  <OptionAreaSection />
  <div class="history-image-area">
    <HistoryAreaSection />
    <ImageAreaSection />
  </div>
</div>

<style>
  .editorv2-container {
    display: grid;
    grid-template-columns: 84px minmax(320px, .9fr) minmax(0, 2.7fr);
    height: calc(100vh - 70px);;
    width: 100%;
    overflow: hidden;
  }

  .history-image-area {
    display: grid;
    grid-template-rows: 0.8fr 3.5fr;
    height: 100%;
  }

  :global(.editorv2-container .apply-btn) {
    margin-top: 0;
    padding-left: 5rem;
    padding-right: 5rem;
  }
  @media (max-width: 800px) {
    .editorv2-container { grid-template-columns: minmax(0, 1fr); height: auto; overflow: visible; }
    .history-image-area { grid-row: 2; grid-template-rows: auto auto; height: auto; min-width: 0; }

  }
</style>
